import cls from './ChildrenAnimation.module.scss';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../shared/redux/store';
import { childNames } from '../../shared/redux/child/types';
import { useEffect } from 'react';
import ChildComponent from '../../shared/ui/ChildComponent/ChildComponent';
import { setEndGame } from '../../shared/redux/pages/slice';
import { incrementCount, setCharge } from '../../shared/redux/game/slice';
import { setIsAnchorFalse } from '../../shared/redux/hooks/slice';

const ChildrenAnimation = () => {
  const children = useSelector((state: RootState) => state.children.children);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setCharge(100));
    dispatch(setIsAnchorFalse());
  }, []);

  useEffect(() => {
    const arr = children.filter((el) => el.isDied || el.reachedTargets);
    const arrDied = children.filter((el) => el.isDied);
    if (arr.length === 6) {
      dispatch(setEndGame(true));
      if (arrDied.length < 6) {
        dispatch(incrementCount());
      }
    }
  }, [children]);

  return (
    <div className={cls.ChildrenAnimation}>
      {!children[0].isDied && !children[0].reachedTargets && (
        <ChildComponent
          child={children[0]}
          name={childNames.BLUE}
          leftStatic={5}
          leftUp={-20}
          static_img={children[0].img}
          anim_up_img={children[0].anim.up}
          anim_down_img={children[0].anim.down}
        />
      )}
      {!children[1].isDied && !children[1].reachedTargets && (
        <ChildComponent
          child={children[1]}
          name={childNames.ORANGE}
          leftStatic={66}
          leftUp={45}
          static_img={children[1].img}
          anim_up_img={children[1].anim.up}
          anim_down_img={children[1].anim.down}
        />
      )}
      {!children[2].isDied && !children[2].reachedTargets && (
        <ChildComponent
          child={children[2]}
          name={childNames.PURPLE}
          leftStatic={112}
          leftUp={97}
          static_img={children[2].img}
          anim_up_img={children[2].anim.up}
          anim_down_img={children[2].anim.down}
        />
      )}
      {!children[3].isDied && !children[3].reachedTargets && (
        <ChildComponent
          child={children[3]}
          name={childNames.PINK}
          leftStatic={170}
          leftUp={150}
          static_img={children[3].img}
          anim_up_img={children[3].anim.up}
          anim_down_img={children[3].anim.down}
        />
      )}
      {!children[4].isDied && !children[4].reachedTargets && (
        <ChildComponent
          child={children[4]}
          name={childNames.GREY}
          leftStatic={220}
          leftUp={200}
          static_img={children[4].img}
          anim_up_img={children[4].anim.up}
          anim_down_img={children[4].anim.down}
        />
      )}
      {!children[5].isDied && !children[5].reachedTargets && (
        <ChildComponent
          child={children[5]}
          name={childNames.YELLOW}
          leftStatic={275}
          leftUp={250}
          static_img={children[5].img}
          anim_up_img={children[5].anim.up}
          anim_down_img={children[5].anim.down}
        />
      )}
    </div>
  );
};

export default ChildrenAnimation;
